import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import Seo from "@/components/Seo";
import { EVENTS } from "@/data/events";
import { orgSchema, breadcrumb } from "@/lib/seo";
import { ArrowRight, CalendarBlank } from "@phosphor-icons/react";

export default function Events() {
  const { t, lang } = useI18n();
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid="events-page">
      <Seo title={t("seo_events_title")}
        description={t("events_sub")} path="/events"
        jsonLd={[orgSchema(), breadcrumb([{ name: "Home", path: "/" }, { name: t("nav_events"), path: "/events" }])]} />
      <p className="font-body text-sm text-[#EF5A1E] font-semibold mb-3">{t("nav_events")}</p>
      <h1 className="font-heading font-bold tracking-tight text-4xl sm:text-5xl text-[#0B1533] leading-[1.05] max-w-3xl">{t("events_title")}</h1>
      <p className="font-body text-[#5A607A] mt-5 text-lg max-w-2xl">{t("events_sub")}</p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-10">
        {EVENTS.map((e) => {
          const c = e[lang] || e.de;
          const month = (e.month && (e.month[lang] || e.month.de)) || "";
          return (
            <Link key={e.slug} to={`/events/${e.slug}`} data-testid={`event-${e.slug}`}
              className="group rounded-2xl border border-[#E9E5DE] bg-white overflow-hidden hover:border-[#EF5A1E] transition-colors duration-200 flex flex-col">
              {e.image && (
                <div className="h-44 overflow-hidden bg-[#0B1533]">
                  <img src={e.image} alt={c.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out" />
                </div>
              )}
              <div className="p-6 flex flex-col flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-body text-xs font-semibold text-[#EF5A1E]">{e.region}</span>
                  {month && <span className="font-body text-[11px] text-[#5A607A] inline-flex items-center gap-1"><CalendarBlank size={12} /> {month}</span>}
                </div>
                <h2 className="font-heading font-bold text-xl tracking-tight text-[#0B1533] mt-2">{c.name}</h2>
                <p className="font-body text-sm text-[#5A607A] mt-2 leading-relaxed flex-1">{c.intro}</p>
                <span className="inline-flex items-center gap-1.5 font-body text-sm font-semibold text-[#0B1533] mt-4 group-hover:text-[#EF5A1E] transition-colors">{t("dest_book_now")} <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" /></span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
